import React from 'react';
import { MainLayout } from '../components/MainLayout';
import { CashFlowPage } from '../components/cash-flow/CashFlowPage';

export function CashFlow() {
  return (
    <MainLayout>
      <CashFlowPage />
    </MainLayout>
  );
}